/**
 * @desc Yung-提交表单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.ApprovalRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/approval/formSubmit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
